export default __webpack_public_path__ + "static/media/image_house-tests.47534af8.svg";